import { render, staticRenderFns } from "./modal-prices.vue?vue&type=template&id=ac6f60e8&"
import script from "./modal-prices.vue?vue&type=script&lang=js&"
export * from "./modal-prices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports